export default __webpack_public_path__ + "Src/Client/Search/savedSearchWidget/newSavedSearchDialog.html";